import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    '& label > span': {
      fontSize: '14px',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  subtitle: {
    fontWeight: 500,
    color: '#000',
    padding: '20px 0 12px 0',
  },
}))
